require('prismjs/themes/prism-solarizedlight.css');
require('./src/prismjs/theme/my-theme.css');
